import {HeaderUnsavedNotice} from "../unsavedChanges/unsavedChanges";
import DemoHeaderOverlay from "./demoHeaderOverlay";
import { hasAdminAccess } from "../../lib/accessPolicy.mjs";
import React, { useContext, useEffect } from "react";
//HOC CSS
import styles from "./styles";
// reach router
import { navigate } from "../../history";

//material ui
import { createTheme, responsiveFontSizes, ThemeProvider, Button, Dialog, Menu, MenuItem, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, AppBar, Toolbar, Box, IconButton, Drawer } from "@mui/material";
import { withStyles } from "tss-react/mui";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

//Logo
import logo from "../../assets/img/logo/final2.png";
//Reach Router
import { Link, NavLink as RouterNavLink, useLocation } from "react-router-dom";
//current user context hook
import { CurrentUserContext } from "../../contexts/currentUserProvider";
import { ResultFieldSettingContext } from "../../contexts/resultFieldSettingProvider";
import { SearchResultContext } from "../../contexts/searchResultProvider";

//Firebase
import { signOut } from "../../firebase";

import Helper from "../helper";

const PublicNavLink = (props) => {
  const { classes, to, children } = props;
  const handleClick = () => {
    if (typeof window === "undefined") {
      return;
    }

    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });

    window.setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, 0);
  };

  return (
    <RouterNavLink
      to={to}
      className={classes.publicNavLink}
      onClick={handleClick}
      style={({ isActive }) => (isActive
        ? {
            color: "var(--wws-accent)",
            borderBottom: "2px solid var(--wws-accent)",
          }
        : undefined)}
    >
      <Typography variant="subtitle1" className={classes.publicNavText}>
        {children}
      </Typography>
    </RouterNavLink>
  );
};

function LandingHeader(props) {
  const { classes } = props;
  return (
    <div data-portal-header className={classes.root} style={{position: "sticky", top: 0, zIndex: 1200}}>
      <ThemeProvider theme={props.theme}>
        <AppBar position="sticky" color="transparent" className={classes.publicHeader}>
          <Toolbar className={classes.publicToolbar}>
            <div className={classes.publicBrand}>
              <img src={logo} alt="logo" className={classes.publicLogoIcon} />
              <Typography variant="h5" className={classes.publicTitle}>
                Worldwide Solutions International
              </Typography>
            </div>

            <div className={classes.publicNav}>
              <PublicNavLink to="/" classes={classes}>Home</PublicNavLink>
              <PublicNavLink to="/about" classes={classes}>About</PublicNavLink>
              <PublicNavLink to="/service" classes={classes}>Service</PublicNavLink>
              <PublicNavLink to="/location" classes={classes}>Location</PublicNavLink>
              <PublicNavLink to="/contact" classes={classes}>Contact</PublicNavLink>
            </div>

            <PublicActionLink to="/login" classes={classes}>
              <Typography variant="body1" className={classes.publicActionText}>
                Log In
              </Typography>
            </PublicActionLink>
          </Toolbar>
        </AppBar>
        <HeaderUnsavedNotice/>
      </ThemeProvider>
    </div>
  );
}

const PublicActionLink = (props) => {
  const { classes, to, children } = props;
  const handleClick = () => {
    if (typeof window === "undefined") {
      return;
    }

    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });

    window.setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, 0);
  };

  return (
    <Link to={to} className={classes.publicActionLink} onClick={handleClick}>
      {children}
    </Link>
  );
};

const NavLink = props => (
  <RouterNavLink
    {...props}
    style={({ isActive }) => ({
      color: isActive ? "var(--wws-accent)" : "var(--wws-paper)"
    })}
  />
);



function DashboardHeader(props) {
  const { classes } = props;
  const currentUser = useContext(CurrentUserContext);
  useEffect(() => {
    const header = document.querySelector("[data-portal-header]");
    if (!header) return undefined;
    const brand = header.querySelector("[data-portal-brand]");
    const measure = () => {
      document.documentElement.style.setProperty("--portal-header-height", `${header.getBoundingClientRect().height}px`);
      header.style.setProperty("--portal-brand-height", `${brand?.getBoundingClientRect().height || 0}px`);
    };
    measure();const observer = new ResizeObserver(measure);observer.observe(header);if (brand) observer.observe(brand);
    return () => observer.disconnect();
  }, []);

  const { resultFieldSetting, dispatchResultFieldSetting } = useContext(ResultFieldSettingContext);
  const { dispatchSearchResult } = useContext(SearchResultContext);

  const [open, setOpen] = React.useState(false);
  const [currentBranch, setCurrentBranch] = React.useState(resultFieldSetting.view);
  const [branchMenuAnchor, setBranchMenuAnchor] = React.useState(null);
  const [accountAnchor, setAccountAnchor] = React.useState(null);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const {pathname} = useLocation();
  useEffect(() => {setMobileOpen(false);setAccountAnchor(null);}, [pathname]);

  let field = "view";
  const branchDisplayName = Helper.getBranchDisplayName(resultFieldSetting.view);
  const branchTimeZoneAbbr = Helper.getBranchTimeZoneAbbr(new Date(), resultFieldSetting.view);

  const getPlanningPathForBranch = (branchCode, routeSegment = "todo") => (
    branchCode === "CHI" ? `/planning_chi/${routeSegment}` : `/planning/${routeSegment}`
  );

  const getNormalizedPlanningPath = (path, branchCode) => {
    const chiMatch = path.match(/^\/planning_chi\/([^/]+)$/);
    if (chiMatch) {
      return getPlanningPathForBranch(branchCode, chiMatch[1]);
    }

    const legacyMatch = path.match(/^\/planning\/([^/]+)_(ny|chi)$/i);
    if (legacyMatch) {
      return getPlanningPathForBranch(branchCode, legacyMatch[1]);
    }

    const nyMatch = path.match(/^\/planning\/([^/]+)$/);
    if (nyMatch) {
      return getPlanningPathForBranch(branchCode, nyMatch[1]);
    }

    return path;
  };

  const blurFocusedElement = () => {
    if (document.activeElement && typeof document.activeElement.blur === "function") {
      document.activeElement.blur();
    }
  };

  const handleClose = () => {
    blurFocusedElement();
    setOpen(false);
  };

  const handleSignOut = async (event) => {
    if (event) {
      event.preventDefault();
    }
    try {
      await signOut();
    } catch (err) {
      console.error("Error signing out:", err);
    }
    navigate("/", { replace: true });
  };

  const handleBranchMenuOpen = event => {
    setBranchMenuAnchor(event.currentTarget);
  };

  const handleBranchMenuClose = () => {
    blurFocusedElement();
    setBranchMenuAnchor(null);
  };

  const selectBranch = value => {
    setCurrentBranch(value);
    handleBranchMenuClose();
    window.setTimeout(() => {
      blurFocusedElement();
      setOpen(true);
    }, 0);
  };

  const handleChange = (e) => {
    let value = (currentBranch === "NY" ? "NY" : "CHI");
    let resultFieldObj = { [`${field}`]: value, cid: true };
    const email = currentUser.email;

    Helper.handleUpdate('resultFields', `${email}`, resultFieldObj,
      function () {
        setOpen(false);
        dispatchResultFieldSetting({ type: "UPDATE_RESULTFIELD", resultField: field, resultFieldInfo: value });

        let path = window.location.pathname;
        if (path.indexOf("/planning") !== -1 ){
          path = getNormalizedPlanningPath(path, value);
        }else if (path.indexOf("/operation") !== -1 ){
          path = "/operation";
        }else if (path.indexOf("/report") !== -1){
          dispatchSearchResult({
            type: "CLEAR_SEARCH_RESULT"
          });
        }
        navigate(path);
      },
      function (dbErr) {
        // console.log("Failed to update the fields: ", dbErr);
        // setServerMessage('Failed To fields');
      });

  };

  useEffect(() => {
    if (currentUser) {
      const email = currentUser.email;

      Helper.handleFetchByReference('resultFields', `${email}`,
        function (doc) {
          if (!doc.exists) {
          } else {
            let value = (doc.data().view === "NY" ? "NY" : "CHI");
            dispatchResultFieldSetting({ type: "UPDATE_RESULTFIELD", resultField: field, resultFieldInfo: value });
          }
        },
        function (dbErr) {
        });

      return () => {
      }
    }
  }, [currentUser, dispatchResultFieldSetting, field]);

  const active = currentUser.status === "active";
  const adminAccess = hasAdminAccess(currentUser);
  const planningAccess = active && ["admin", "manager", "member1"].includes(currentUser.role);
  const links = [
    ...(active ? [{label:"Operation",to:"/operation",prefix:"/operation"}] : []),
    ...(planningAccess ? [{label:"Planning",to:getPlanningPathForBranch(resultFieldSetting.view),prefix:"/planning"}] : []),
    ...(adminAccess ? [{label:"Messaging",to:"/messaging",prefix:"/messaging"}] : []),
    ...(active ? [{label:"Report",to:"/report",prefix:"/report"}] : []),
    ...(adminAccess ? [{label:"Admin",to:"/admin",prefix:"/admin"}] : []),
  ];
  const navigation = mobile => links.map(item => <RouterNavLink key={item.label} to={item.to}
    className={`${classes.portalNavItem} ${pathname.startsWith(item.prefix) ? classes.portalNavActive : ""}`}
    onClick={()=>{currentUser.path=item.to;if(mobile)setMobileOpen(false);}}>{item.label}</RouterNavLink>);
  return (
    <>
      <div data-portal-header className={classes.portalShell}>
        <ThemeProvider theme={props.theme}>
          <AppBar component="div" position="static" className={classes.privateHeader}>
            <div data-portal-brand>
              <DemoHeaderOverlay enabled={adminAccess && currentUser.demoMode === true}/>
              <Toolbar className={classes.portalMasthead}>
                <div className={classes.portalBrand}>
                  <img src={logo} alt="WSI logo" className={classes.logoIcon}/>
                  <Typography component="span" className={classes.portalBrandName}>Worldwide Solutions</Typography>
                </div>
                {planningAccess && <div className={classes.portalBranchGroup}>
                  <button type="button" className={classes.branchTrigger} aria-label={`Branch ${branchDisplayName}`} aria-haspopup="menu" aria-expanded={Boolean(branchMenuAnchor)} onClick={handleBranchMenuOpen}>
                    <span className={classes.branchTriggerLabel}>Branch</span><span className={classes.branchTriggerValue}>{branchDisplayName}</span><ExpandMoreRoundedIcon className={classes.branchTriggerIcon}/>
                  </button>
                  <span className={classes.portalBranchTime}>{`${branchDisplayName} Time (${branchTimeZoneAbbr})`}</span>
                </div>}
                <IconButton className={classes.portalAccountButton} aria-label="Account menu" aria-haspopup="menu" aria-expanded={Boolean(accountAnchor)} onClick={e=>setAccountAnchor(e.currentTarget)}><AccountCircleOutlinedIcon/></IconButton>
                <IconButton className={classes.portalMobileMenu} aria-label="Open navigation menu" aria-expanded={mobileOpen} onClick={()=>setMobileOpen(true)}><MenuRoundedIcon/></IconButton>
              </Toolbar>
            </div>
            <Box className={classes.portalNavigationRow}>
              <HeaderUnsavedNotice compact/>
              <Box component="nav" aria-label="Main navigation" className={classes.portalNavigation}>{navigation(false)}</Box>
            </Box>
          </AppBar>
        </ThemeProvider>
      </div>
      <Menu anchorEl={accountAnchor} open={Boolean(accountAnchor)} onClose={()=>setAccountAnchor(null)} slotProps={{paper:{sx:{borderRadius:3,minWidth:240,mt:1}}}}>
        <Box sx={{px:2,py:1,maxWidth:320}}><Typography variant="body2" sx={{overflowWrap:"anywhere",fontWeight:700}}>{currentUser.email}</Typography><Typography variant="caption" sx={{
          color: "text.secondary"
        }}>{currentUser.role === "member1" ? "Member 1" : currentUser.role}</Typography></Box>
        <MenuItem nativeButton={false} component={Link} to="/user" onClick={()=>setAccountAnchor(null)}>Profile &amp; preferences</MenuItem>
        <MenuItem onClick={event=>{setAccountAnchor(null);handleSignOut(event);}}>Sign out</MenuItem>
      </Menu>
      <Drawer anchor="right" open={mobileOpen} onClose={()=>setMobileOpen(false)} slotProps={{paper:{sx:{width:272,maxWidth:"calc(100vw - 24px)",top:72,right:12,bottom:"auto",height:"auto",maxHeight:"calc(100dvh - 84px)",background:"#10367f",color:"white",borderRadius:"16px"},role:"dialog","aria-modal":true,"aria-label":"Navigation menu"}}}>
        <Box sx={{display:"flex",alignItems:"center",justifyContent:"space-between",px:2,py:1}}><Typography variant="h6">Navigation</Typography><IconButton sx={{color:"white"}} aria-label="Close navigation menu" onClick={()=>setMobileOpen(false)}><CloseRoundedIcon/></IconButton></Box>
        <Box component="nav" aria-label="Mobile navigation" sx={{display:"flex",flexDirection:"column",gap:0.25,px:1.5,pb:1}}>{navigation(true)}</Box>
        <Box sx={{p:1.5,borderTop:"1px solid #ffffff30"}}>
          <Box sx={{px:2,py:0.5,mb:0.5}}>
            <Typography variant="body2" sx={{overflowWrap:"anywhere",fontWeight:700}}>{currentUser.email}</Typography>
            <Typography variant="caption" sx={{color:"#c5d6f2"}}>{currentUser.role === "member1" ? "Member 1" : currentUser.role}</Typography>
          </Box>
          <Link className={`${classes.portalNavItem} ${pathname === "/user" ? classes.portalNavActive : ""}`} to="/user" onClick={()=>setMobileOpen(false)}>Profile &amp; preferences</Link>
          <Button fullWidth onClick={event=>{setMobileOpen(false);handleSignOut(event);}} sx={{mt:1,minHeight:44,justifyContent:"flex-start",px:2,borderRadius:3,color:"white",textTransform:"none",border:"1px solid #ffffff40","&:hover":{background:"#ffffff18"}}}>Sign out</Button>
        </Box>
      </Drawer>
      <Menu anchorEl={branchMenuAnchor} open={Boolean(branchMenuAnchor)} onClose={handleBranchMenuClose} classes={{paper:classes.branchMenuPaper}}>
        <MenuItem selected={resultFieldSetting.view === "NY"} className={classes.branchMenuItem} onClick={()=>selectBranch("NY")}>New York</MenuItem>
        <MenuItem selected={resultFieldSetting.view === "CHI"} className={classes.branchMenuItem} onClick={()=>selectBranch("CHI")}>Chicago</MenuItem>
      </Menu>
      <Dialog open={open} onClose={handleClose} aria-labelledby="branch-change-title" slotProps={{
        paper: {className:classes.branchDialogPaper}
      }}>
        <DialogTitle id="branch-change-title" className={classes.branchDialogTitle}>Switch branch?</DialogTitle>
        <DialogContent className={classes.branchDialogContent}><DialogContentText className={classes.branchDialogText}>Switching branch will discard your unsaved changes. Continue?</DialogContentText></DialogContent>
        <DialogActions className={classes.branchDialogActions}><Button className={classes.branchDialogSecondaryButton} onClick={()=>{setCurrentBranch(resultFieldSetting.view);handleClose();}}>Cancel</Button><Button className={classes.branchDialogPrimaryButton} onClick={handleChange}>Switch branch</Button></DialogActions>
      </Dialog>
    </>
  );
}

export function Header(props) {
  const { classes } = props;
  const currentUser = useContext(CurrentUserContext);
  let theme = createTheme();
  theme = responsiveFontSizes(theme);

  return (
    <>
      {currentUser ? (
        <DashboardHeader path="/" classes={classes} theme={theme} />
      ) : (
        <LandingHeader classes={classes} theme={theme} />
      )}
    </>
  );
}

export default withStyles(Header, styles);
